import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TenantAssignment } from './tenant-assignment';
export { TenantAssignment };
import { tenantAssignmentSchema } from '@schemas/business-objects/tenant-assignment';
import { TenantFormGroup } from './tenant-form-group';
import { UserFormGroup } from './user-form-group';

export class TenantAssignmentFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
    userId: SchemaFormControl;
    user: UserFormGroup;
  };

  declare value: Partial<TenantAssignment>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(tenantAssignmentSchema, TenantAssignment, data, options);
  }

  get object(): TenantAssignment {
    return new TenantAssignment(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'tenant':
        return new TenantFormGroup();
      case 'user':
        return new UserFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<TenantAssignment[]> {
    return TenantAssignment.find(filter);
  }

  static async findOne(filter?: any): Promise<TenantAssignment | null> {
    return TenantAssignment.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<TenantAssignment> {
    return TenantAssignment.findById(id, filter);
  }

  static async create(
    data: Partial<TenantAssignment>,
  ): Promise<TenantAssignment> {
    return TenantAssignment.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<TenantAssignment>,
  ): Promise<TenantAssignment> {
    return TenantAssignment.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return TenantAssignment.deleteById(id);
  }
}

export class TenantAssignmentFormArray extends PersistedFormArray {
  declare controls: TenantAssignmentFormGroup[];

  readonly entityName = 'TenantAssignment' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(tenantAssignmentSchema, TenantAssignment, options);
  }

  protected override createItemGroup() {
    return new TenantAssignmentFormGroup();
  }

  get array(): TenantAssignment[] {
    return this.controls.map(
      (group: TenantAssignmentFormGroup) => group.object,
    );
  }
}

export class TenantAssignmentPersistedArray extends PersistedArray<TenantAssignment> {
  readonly entityName = 'TenantAssignment' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TenantAssignment, options);
  }
}
